import {
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  CLEAR_PROFILE_MESSAGES
} from '../constants/profileConstants';

export const editProfileRequest = () => ({
  type: EDIT_PROFILE_REQUEST
});

export const editProfileSuccess = (user) => ({
  type: EDIT_PROFILE_SUCCESS,
  payload: user
});

export const editProfileFailure = (error) => ({
  type: EDIT_PROFILE_FAILURE,
  payload: error
});

export const clearProfileMessages = () => ({
  type: CLEAR_PROFILE_MESSAGES
});

export const editProfile = (profileData) => ({
  type: 'EDIT_PROFILE_SAGA',
  payload: profileData
});

export const changePasswordRequest = (passwordData) => ({
  type: 'CHANGE_PASSWORD_SAGA',
  payload: passwordData
});

export const verifyEmailRequest = (emailData) => ({
  type: 'VERIFY_EMAIL_SAGA',
  payload: emailData
});

export const getAdminProfileRequest = (id) => ({
  type: 'GET_ADMIN_PROFILE_SAGA',
  payload: id
});

export const getAdminProfileSuccess = (data) => ({
  type: 'GET_ADMIN_PROFILE_SUCCESS',
  payload: data
});

export const getAdminProfileFailure = (error) => ({
  type: 'GET_ADMIN_PROFILE_FAILURE',
  payload: error
});

export const updateLogoRequest = (logoData) => ({
  type: 'UPDATE_LOGO_SAGA',
  payload: logoData
});

export const resetPasswordRequest = (resetData) => ({
  type: 'CHANGE_PASSWORD_SAGA',
  payload: resetData
});

export const verifyMailRequest = (mailData) => ({
  type: 'VERIFY_MAIL_SAGA',
  payload: mailData
});